'use client'
import { HttpLink, from } from '@apollo/client'
import { ApolloNextAppProvider, ApolloClient, InMemoryCache } from '@apollo/client-integration-nextjs'
import { setContext } from '@apollo/client/link/context'

interface ApolloConfig {
  uri: string
  publicToken: string
  privateToken: string
}

interface ApolloProviderProps extends React.PropsWithChildren {
  config: ApolloConfig
}

// you need to create a component to wrap your app in
export function ApolloProvider({ children, config }: ApolloProviderProps) {
  // have a function to create a client for you
  function makeClient() {
    const httpLink = new HttpLink({
      uri: config.uri,
      // credentials: 'include',
      fetchOptions: {
        next: {
          cache: 'no-store',
          revalidate: 0,
        },
      },
    })

    // Inject dynamic headers based on the query context
    const authLink = setContext((operation, { headers, ...rest }) => {
      // Extract context from the operation context or the rest parameter
      const operationContext = operation.context || {}
      const queryContext = { ...operationContext, ...rest }

      const isPrivate = queryContext?.privateStore
      const DYCustomerToken = queryContext?.DYCustomerToken
      const DYGuestCartToken = queryContext?.DYGuestCartToken

      // console.log('🟣 ApolloClient | operation name:', operation.operationName)
      // console.log('🟣 ApolloClient | operation context:', operation.context)
      // console.log('🟣 ApolloClient | rest params:', rest)
      // console.log('🟣 ApolloClient | isPrivate:', isPrivate)
      // console.log('🟣 ApolloClient | DYCustomerToken:', DYCustomerToken)

      const selectedToken = isPrivate ? config.privateToken : config.publicToken
      // console.log('🟣 ApolloClient | selected token type:', isPrivate ? 'PRIVATE' : 'PUBLIC')

      const newHeaders = {
        ...headers,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'DY-Access-Token': selectedToken,
        ...(typeof DYCustomerToken === 'string' && DYCustomerToken && {
          'DY-Customer-Token': DYCustomerToken
        }),
        ...(typeof DYGuestCartToken === 'string' && DYGuestCartToken && {
          'DY-Guest-Cart-Token': DYGuestCartToken
        }),
      }

      return {
        headers: newHeaders
      }
    })

    // use the `ApolloClient` from "@apollo/client-integration-nextjs"
    const link = from([authLink, httpLink])

    return new ApolloClient({
      // use the `InMemoryCache` from "@apollo/client-integration-nextjs"
      cache: new InMemoryCache(),
      link,
      // defaultOptions: {
      //   watchQuery: {
      //     errorPolicy: 'all'
      //   },
      //   query: {
      //     errorPolicy: 'all'
      //   }
      // }
    })
  }

  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  )
}
